require.register("ffss/component/row/ClubDetail", function(exports, require, module){
  $0
  
});

